const isZoneMode = () => window.sessionStorage.getItem('id_zone');
const isChildMode = () => window.sessionStorage.getItem('master_mono_child');
const connectAsDemand = () => window.sessionStorage.getItem('master_mono');

/**
 * get access for a specified entity
 * @param {Object} accesses object from access reducer
 * @param {("category" | "product" | "product_menu" | "category_supplement" | "supplement" | "price_category" | "tax_rate" | "exclusion")} entity
 */
export const getAccess = (accesses, entity) => {
	if (accesses.current.hasOwnProperty(entity)) {
		return accesses.current[entity];
	} else {
		return {
			create: false,
			read: false,
			update: false,
			delete: false,
		};
	}
};

/**
 * return all entities access
 * @param {Object} accesses object from access reducer
 */
export const getEntitiesAccess = accesses => {
	if (accesses && accesses.current) {
		return Object.keys(accesses.current).reduce((acc, entity) => {
			acc[entity] = accesses.current[entity];
			return acc;
		}, {});
	} else {
		return { create: false, read: false, update: false, delete: false };
	}
};

/**
 * get access for a specified entity
 * @param {Object} accesses object from access reducer
 * @param {("category" | "product" | "product_menu" | "category_supplement" | "supplement" | "price_category" | "tax_rate" | "exclusion")} entity
 */
export const getZoneAccess = (accesses, entity) => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		return accesses.config[entity] || {};
	} else {
		return false;
	}
};

/**
 * Get the access based on vertical merge options
 * @param {*} accesses
 * @param {*} entity
 * @param {*} field
 * @param {*} asso
 * @returns
 */
export const isAccessDisabled = (accesses, entity, field) => {
	if (connectAsDemand()){
		return false;
	}
	if (isZoneMode() || isChildMode()) {
		if (accesses[entity] && accesses[entity][field] && accesses[entity][field].updateType == 'old_value') return false;
		if (accesses[entity] && accesses[entity][field]) return true;
		return false;
	} else {
		return false;
	}
};

// Clé qui porte le statut du contenu, quand ce n'est pas addIfMissing.
// Sur les catégories de modificateurs, addIfMissing reste vrai dans les deux
// états — le siège continue d'alimenter la catégorie — et c'est
// removeIfMissing qui dit si l'établissement peut y ajouter les siens : ne
// plus retirer ce qu'il a ajouté, c'est le laisser faire. À garder aligné sur
// l'appariement 'keepAdd' du serveur et sur CONTENT_STATUS_FIELD de
// utils/verticalMergeRules.
const CONTENT_STATUS_FIELD = {
	category_supplement_product: 'removeIfMissing',
};

export const canAddAsso = (accesses, entity, field) => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		const statusField = CONTENT_STATUS_FIELD[entity] || 'addIfMissing';
		if (
			accesses[entity] &&
			accesses[entity][field] &&
			accesses[entity][field][statusField]
		)
			return false;
		return true;
	}

	return true;
};

export const canRemoveAsso = (accesses, entity, field) => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (
			accesses[entity] &&
			accesses[entity][field] &&
			accesses[entity][field]['removeIfMissing']
		)
			return false;
		return true;
	}

	return true;
};

export const canReweightAsso = (accesses, entity, field) => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (
			accesses[entity] &&
			accesses[entity][field] &&
			accesses[entity][field]['updateOptions'] &&
			accesses[entity][field]['updateOptions']['updateWeight']
		)
			return false;
		return true;
	}

	return true;
};

export const canUpdateRulesAsso = (accesses, entity, field) => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (
			accesses[entity] &&
			accesses[entity][field] &&
			accesses[entity][field]['updateOptions'] &&
			accesses[entity][field]['updateOptions']['updateRules']
		)
			return false;
		return true;
	}

	return true;
};

export const canUpdateColorsAsso = (accesses, entity, field) => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (
			accesses[entity] &&
			accesses[entity][field] &&
			accesses[entity][field]['updateOptions'] &&
			accesses[entity][field]['updateOptions']['updateColors']
		)
			return false;
		return true;
	}

	return true;
};

export const canUpdatePriceAsso = (accesses, entity, field) => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (entity && field) {
			if (
				accesses[entity] &&
				accesses[entity][field] &&
				accesses[entity][field]['updateOptions'] &&
				accesses[entity][field]['updateOptions']['updatePrice']
			) {
				if (accesses[entity][field]['updateOptions']['updatePrice']['updateType'] && accesses[entity][field]['updateOptions']['updatePrice']['updateType'] == 'old_value'){
					return true;
				}
				return false;
			}
		} else if (
			accesses['price'] &&
			accesses['price']['id_price_category#price_type#id_parent#id_table'] &&
			accesses['price']['id_price_category#price_type#id_parent#id_table'][
				'updateOptions'
			] &&
			accesses['price']['id_price_category#price_type#id_parent#id_table'][
				'updateOptions'
			]['updatePrice']
		) {
			if (accesses['price']['id_price_category#price_type#id_parent#id_table'][
				'updateOptions'
			]['updatePrice']['updateType'] == 'old_value') {
				return true;
			}
			return false;
		}

		return true;
	}

	return true;
};

export const canAddPriceAsso = accesses => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (
			accesses['price'] &&
			accesses['price']['id_price_category#price_type#id_parent#id_table'] &&
			accesses['price']['id_price_category#price_type#id_parent#id_table'][
				'addIfMissing'
			]
		)
			return false;
		return true;
	}

	return true;
};

export const canRemovePriceAsso = accesses => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (
			accesses['price'] &&
			accesses['price']['id_price_category#price_type#id_parent#id_table'] &&
			accesses['price']['id_price_category#price_type#id_parent#id_table'][
				'removeIfMissing'
			]
		)
			return false;
		return true;
	}

	return true;
};

export const canAddZoneAsso = accesses => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (
			accesses['floor_exclusion_menu'] &&
			accesses['floor_exclusion_menu'][
				'id_floor#counter_type#exclusion_type#id_parent#id_table'
			] &&
			accesses['floor_exclusion_menu'][
				'id_floor#counter_type#exclusion_type#id_parent#id_table'
			]['addIfMissing']
		)
			return false;
		return true;
	}

	return true;
};

export const canRemoveZoneAsso = accesses => {
	if (connectAsDemand()){
		return true;
	}
	if (isZoneMode() || isChildMode()) {
		if (
			accesses['floor_exclusion_menu'] &&
			accesses['floor_exclusion_menu'][
				'id_floor#counter_type#exclusion_type#id_parent#id_table'
			] &&
			accesses['floor_exclusion_menu'][
				'id_floor#counter_type#exclusion_type#id_parent#id_table'
			]['removeIfMissing']
		)
			return false;
		return true;
	}

	return true;
};
